import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';
import { GET_KIOSK_ADMIN_TOKEN } from 'modules/selfServices/actionTypes';

import isDownloading from './isDownloading';
import model from './model';
import onSiteLink from './onSiteLink';
import sendWizard from './sendWizard';
/**
 * @typedef {{
 *  model: import('./model').ModelState,
 *  isDownloading: import('./isDownloading').IsDownloadingState,
 *  sendWizard: import('./sendWizard').SelfServiceSendWizardReducer,
 *  onSiteLink: import('./onSiteLink').SelfServiceOnSiteLinkReducer,
 *  isKioskAdminTokenFetching: boolean
 * }} UIState
 */

export default combineReducers({
  model,
  isDownloading,
  sendWizard,
  onSiteLink,
  isKioskAdminTokenFetching: loading(GET_KIOSK_ADMIN_TOKEN),
});
